import { Box, Grid, Stack, Typography } from '@mui/material';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';

import GlobalDatagrid from '../../../components/mui/DataGrid/GlobalDatagrid';
import { refundColumns } from './util/getColumns';
import { useEffect, useMemo, useRef, useState } from 'react';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import ReasonEdit from './components/ReasonEdit';
import TutorsTable from './components/TutorsTable';
import RequestStats from '../RequestStats';
import dayjs from 'dayjs';
import GlobalRefundApprovalReject from '../GlobalRefundApprovalReject';
import DetailsAction from './components/DetailsAction';
import { TableHead_Refund_fn } from '../../../components/datagrid/refund/RefundRequestTableHead';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getApprovalRequests, getVerificationRequests } from '../../../redux/features/refundSlice';
import GlobalSelectFieldWithoutFormikNew from '../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import FromAndToDatePicker from '../../../components/mui/FromAndToDatePicker';
import { refundGlobalStatus } from '../../../utils/constants/GlobalStaticData';
import { openChat, setRefreashNeeded } from '../../../redux/features/chatSlice';
import ChatDrawer from '../../chatSystem/ChatDrawer';

export default function VerifyApprove({ verify }) {
  const [openRejectionReason, setOpenRejectionReason] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD')); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [approvalModal, setApprovalModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openTutorsTable, setOpenTutorsTable] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [editReason, setEditReason] = useState('');
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search } = paginationData;
  const [selectedStatus, setSelectedStatus] = useState({});
  const dispatch = useDispatch();
  const { refundApprovalsData, loading } = useSelector((state) => state.refund);
  const [chatOpen, setChatOpen] = useState(false);
  const { open: chatOpenFromRedux, refreashNeeded } = useSelector((state) => state.chat);
  const prevOpenRef = useRef(chatOpenFromRedux);

  const dispatchParams = useMemo(() => {
    return {
      gridSize,
      pageNum,
      search,
      fromDate,
      toDate,
      status: selectedStatus?.id,
    };
  }, [pageNum, gridSize, search, fromDate, toDate]);

  useEffect(() => {
    dispatch(verify ? getVerificationRequests(dispatchParams) : getApprovalRequests(dispatchParams));
  }, [dispatch, dispatchParams, verify]);

  useEffect(() => {
    if (!chatOpen || !selectedRow) return;
    dispatch(
      openChat({
        chatRoomId: selectedRow?.chat_room_id || null,
        groupCreationUsersList: selectedRow?.related_users || [],
        groupName:selectedRow?.chat_room_id ? `Refund - ${selectedRow?.student_name}-${selectedRow?.expense_id}` :null,
        rowDetails: selectedRow,
      })
    );
    setChatOpen(false);
  }, [chatOpen]);

  useEffect(() => {
    const justClosed = prevOpenRef.current === true && chatOpenFromRedux === false;
    if (justClosed && refreashNeeded) {
      dispatch(verify ? getVerificationRequests(dispatchParams) : getApprovalRequests(dispatchParams));
      dispatch(setRefreashNeeded(false));
    }
    prevOpenRef.current = chatOpenFromRedux;
  }, [chatOpenFromRedux, dispatchParams, refreashNeeded]);

  const COLUMNS = useMemo(
    () =>
      TableHead_Refund_fn({
        setOpenTutorsTable,
        setOpenRejectionReason,
        selectedType: 0,
        setOpenDetails,
        setChatOpen,
        setSelectedRow,
        setApprovalModal,
        setEditReason,
        approvalOrVerify: true,
      }),
    []
  );

  const GLOBAL_DIALOGUE = [
    {
      open: openRejectionReason,
      setOpen: setOpenRejectionReason,
      title: 'Bank Account Details',
      content: <ReasonEdit setOpen={setOpenRejectionReason} reason={editReason} rowData={selectedRow} />,
    },
    {
      open: Boolean(openTutorsTable),
      setOpen: setOpenTutorsTable,
      title: 'Tutors',
      content: <TutorsTable ids={openTutorsTable} />,
    },
    {
      open: Boolean(openDetails),
      setOpen: setOpenDetails,
      title: 'Details',
      content: <DetailsAction data={openDetails} />,
    },
  ];

  return (
    <GlobalWrapper title={`Refund ${verify ? 'Verification' : 'Approval'}`}>
      <Box>
        <RequestStats loading={loading} requestStats={refundApprovalsData?.meta} />
      </Box>
      <Grid container spacing={2} my={3}>
        <Grid item xs={12} md={6} lg={4}>
          <FromAndToDatePicker
            disabled={false}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
            fullWidth={true}
          />
        </Grid>

        {/* <Grid item xs={12} md={6} lg={4}>
          <GlobalSelectFieldWithoutFormikNew
            keys={{ itemId: 'id', itemValue: 'label' }}
            data={refundGlobalStatus}
            label={'Refund Status'}
            fullWidth={true}
            selectedDetails={selectedStatus}
            setChange={setSelectedStatus}
          />
        </Grid> */}
      </Grid>

      <Box>
        <GlobalDatagrid
          tableHead={COLUMNS}
          rowUniqueId={'sl_no'}
          rows={refundApprovalsData?.data}
          meta={refundApprovalsData?.meta?.totalRecords}
          loading={loading}
        />
      </Box>
      <Box>
        {approvalModal && (
          <GlobalRefundApprovalReject
            open={approvalModal}
            setOpen={setApprovalModal}
            rowData={selectedRow}
            dispatchParams={dispatchParams}
            loading={false}
            action={verify ? 'verify' : 'approval'}
            apiDispatchAfterSuccess={verify ? getVerificationRequests : getApprovalRequests}
          />
        )}
        {GLOBAL_DIALOGUE.map(({ open, content, setOpen, title }, i) => (
          <GlobalDialog
            key={i}
            maxWidth={'100%'}
            content={content}
            open={open}
            setOpen={setOpen}
            closeButton={true}
            title={title}
          />
        ))}

        {chatOpen && (
          <ChatDrawer
            open={chatOpen}
            setOpen={setChatOpen}
            chatRoomId={selectedRow?.chat_room_id}
            groupCreationUsersList={selectedRow?.related_users}
            groupName={`Refund - ${selectedRow?.student_name}-${selectedRow?.expense_id}`}
            chatCloseFunction={() => {
              dispatch(verify ? getVerificationRequests(dispatchParams) : getApprovalRequests(dispatchParams));
            }}
            rowDetails={selectedRow}
          />
        )}
      </Box>
    </GlobalWrapper>
  );
}
